export default "__VITE_ASSET__BMf8tJ$r__"